import MembershipProfile from '@components/membership/membership-profile/MembershipProfile'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'

const ComplementaryItemsSection = () => {
  const { id } = useMembershipProfileContext()

  return <MembershipProfile.ComplementaryItemSection id={id} />
}

export default ComplementaryItemsSection
